<template>
  <div class="main-bg">
    <hello-world />
  </div>
</template>

<script>
import HelloWorld from '../components/HelloWorld'

export default {
  name: 'Home',

  components: {
    HelloWorld,
  },
}
</script>
<style scoped>
.main-bg {
  /* Este es el gris claro que se ve de fondo en tu imagen */
  background-color: #f5f5f5; 
  /* Ocupa el alto disponible restando el header (aprox 64px) */
  min-height: calc(100vh - 100px);
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
